export function Export(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.1816 21.564C19.8644 21.4698 21.2 20.0754 21.2 18.369V14.369L21.1938 14.2464C21.1324 13.6412 20.6213 13.169 20 13.169C19.3373 13.169 18.8 13.7063 18.8 14.369V18.369L18.7938 18.4694C18.7444 18.8639 18.4078 19.169 18 19.169H4L3.89965 19.1628C3.50519 19.1134 3.2 18.7769 3.2 18.369V14.369L3.19381 14.2464C3.13235 13.6412 2.62132 13.169 2 13.169C1.33726 13.169 0.800001 13.7063 0.800001 14.369V18.369L0.805067 18.5506C0.899206 20.2335 2.29363 21.569 4 21.569H18L18.1816 21.564Z"
          fill="currentColor"
        />
        <path
          d="M17.1611 6.59483C17.5637 6.12518 17.5397 5.43395 17.1256 4.99321L17.031 4.90277L12.4317 0.960589C11.6536 0.293641 10.526 0.256589 9.70907 0.849431L9.56826 0.960589L4.96905 4.90277C4.46586 5.33407 4.40759 6.09163 4.83889 6.59483C5.24145 7.06447 5.9282 7.14654 6.42709 6.80473L6.53095 6.72498L9.8 3.92331V16.052C9.8 16.7147 10.3373 17.252 11 17.252C11.6213 17.252 12.1324 16.7798 12.1938 16.1747L12.2 16.052V3.92331L15.4691 6.72498C15.9722 7.15629 16.7298 7.09802 17.1611 6.59483Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
